const NAMESPACE = 'jbp-manager-dashboard'

export const TRANSLATION_KEYS = {
  topPartners: {
    tabs: {
      flagged: `${NAMESPACE}-top-partners--tabs-flagged`,
    },
    charts: {
      byMarket: `${NAMESPACE}--charts-by-market`,
      byCountry: `${NAMESPACE}--charts-by-country`,
    },
    mainInfo: {
      title: `${NAMESPACE}--main-info-mainInfo`,
      checkbox: `${NAMESPACE}--main-info-checkbox`,
      all: `${NAMESPACE}--main-info-all`,
      new: `${NAMESPACE}--main-info-new`,
      wip: `${NAMESPACE}--main-info-wip`,
    },
    table: {
      coverage: `${NAMESPACE}-top-partners--table-coverage`,
      market: `${NAMESPACE}-top-partners--table-market`,
      partnerName: `${NAMESPACE}-top-partners--table-partner-name`,
      location: `${NAMESPACE}-top-partners--table-location`,
      pid: `${NAMESPACE}-top-partners--table-pid`,
      pbm: `${NAMESPACE}-top-partners--table-pbm`,
      country: `${NAMESPACE}-top-partners--table-country`,
      partnerFlag: `${NAMESPACE}--partner-flag`,
      requestStatus: `${NAMESPACE}--request-status`,
    },
    filters: {
      export: `${NAMESPACE}-top-partners--filters-export`,
      title: `${NAMESPACE}-top-partners--filters-title`,
      partnerId: `${NAMESPACE}-top-partners--filters-partnerId`,
      partnerIdTooltip: `${NAMESPACE}-top-partners--partnerId-tooltip`,
      geo: `${NAMESPACE}-top-partners--filters-geo`,
      switcher: `${NAMESPACE}-top-partners--filters-switcher`,
      clear: `${NAMESPACE}-top-partners--filters-clear`,
    },
    addNewTopPartner: {
      addPartner: `${NAMESPACE}-top-partners--add-partner`,
      title: `${NAMESPACE}-top-partners--add-new-top-partner-title`,
      subTitle: `${NAMESPACE}-top-partners--add-new-top-partner-sub-title`,
      btnText: `${NAMESPACE}-top-partners--add-new-top-partner-btn-text`,
    },
    editModal: {
      title: `${NAMESPACE}-top-partners--edit-modal-title`,
      addFlagPartnerTitle: `${NAMESPACE}-top-partners--edit-modal-add-flag-partner-title`,
      partnerName: `${NAMESPACE}-top-partners--edit-modal-partner-name`,
      country: `${NAMESPACE}-top-partners--edit-modal-country`,
      coverageImpact: `${NAMESPACE}-top-partners--edit-modal-coverage-impact`,
      flags: `${NAMESPACE}-top-partners--edit-modal-flags`,
      save: `${NAMESPACE}-top-partners--edit-modal-save`,
      remove: `${NAMESPACE}-top-partners--edit-modal-remove`,
      approve: `${NAMESPACE}-top-partners--edit-modal-approve`,
      reject: `${NAMESPACE}-top-partners--edit-modal-reject`,
      cancel: `${NAMESPACE}-top-partners--edit-modal-cancel`,
      newMessage: `${NAMESPACE}-top-partners--edit-modal-new-message`,
      wipMessage: `${NAMESPACE}-top-partners--edit-modal-wip-message`,
      seeDetails: `${NAMESPACE}-top-partners--edit-modal-see-details`,
    },
    cards: {
      card: {
        addedFlags: `${NAMESPACE}-top-partners--cards-card-added-flags`,
        removedFlags: `${NAMESPACE}-top-partners--cards-card-removed-flags`,
        addedFlag: `${NAMESPACE}-top-partners--cards-card-added-flag`,
        removedFlag: `${NAMESPACE}-top-partners--cards-card-removed-flag`,
      },
    },
    removeFlag: {
      removeRequestTooltip: `${NAMESPACE}-top-partners--remove-flag-remove-request-tooltip`,
      createRequestTooltip: `${NAMESPACE}-top-partners--remove-flag-create-request-tooltip`,
      removeRequestConfirmTitle: `${NAMESPACE}-top-partners--remove-flag-remove-request-confirm-title`,
      removeRequestConfirmContent: `${NAMESPACE}-top-partners--remove-flag-remove-request-confirm-content`,
      createRequestConfirmTitle: `${NAMESPACE}-top-partners--remove-flag-create-request-confirm-title`,
      createRequestConfirmContent: `${NAMESPACE}-top-partners--remove-flag-create-request-confirm-content`,
      coverageImpact: `${NAMESPACE}-top-partners--remove-flag-coverage-impact`,
      confirmBtn: `${NAMESPACE}-top-partners--remove-flag-confirm-btn`,
      cancelBtn: `${NAMESPACE}-top-partners--remove-flag-cancel-btn`,
    },
  },
}
